<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      :breadcrumbs="breadcrumbs"
      icon="mdi-package-variant"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1">
        <v-col cols="12" class="content_category mb-3 rounded-lg">
            <v-row class="pl-3">
              <v-col cols="12" class="content_category rounded-lg d-flex">
                <h3 class="mt-2">Banner</h3>
                <v-btn
                  class="ml-5 mb-5"
                  color="primary"
                  @click="addBanner()"
                >
                  Thêm
                </v-btn>
              </v-col>
              <v-col cols="6" class="content_category mb-3 rounded-lg" v-for="(item, index) in banners" :key="index">
                <form-link class="content_category mr-2 rounded-lg content_banner" :banner="item" @updateBanner="updateBanner" @removeBanner="removeBanner" :index="index" :hiddenMobile="true"> </form-link>
              </v-col>
            </v-row>
        </v-col>
        <v-col cols="12" class="content_category mb-3 rounded-lg">
            <v-col>
                <v-col>
                    <v-row>
                        <h3 class="ml-1 mt-2 mb-3">Cấu hình tại sao mua hàng</h3>
                    </v-row>
                </v-col>
                <v-col cols="12" class="mb-3">
                    <v-row>
                        <v-row>
                            <v-col cols="12">
                            <v-text-field
                                background-color="#EDF2F7"
                                filled
                                label="Tiêu đề"
                                v-model="whybuy.title"
                                placeholder="Tiêu đề"
                            ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                            <v-text-field
                                background-color="#EDF2F7"
                                filled
                                label="Tiêu đề con"
                                v-model="whybuy.sub_title"
                                placeholder="Tiêu đề con"
                            ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-row>
                </v-col>
                <v-col>
                    <v-row>
                        <h3 class="ml-1 mt-2 mb-3">Mô tả</h3>
                    </v-row>
                </v-col>
                <v-col cols="12" class="mb-3">
                    <v-row>
                        <v-row>
                            <v-col cols="12" class="content-textarea">
                                <v-textarea
                                    background-color="#EDF2F7"
                                    filled
                                    label="Mô tả"
                                    v-model="whybuy.description"
                                    placeholder="Nhập mô tả ngắn"
                                >
                                </v-textarea>
                            </v-col>
                        </v-row>
                    </v-row>
                </v-col>
                <v-col cols="12" class="mb-3">
                    <v-row>
                        <v-row>
                            <v-col cols="3">
                              <v-file-input
                                label="Ảnh"
                                placeholder="Tải ảnh lên"
                                prepend-icon="mdi-camera"
                                @change="fileSelectWhyBuy($event)"
                              ></v-file-input>
                              <v-img :src="whybuy.photo_url_path"></v-img>
                              <v-text-field v-if="whybuy.photo_url_path"
                                  background-color="#EDF2F7"
                                  filled
                                  label="Alt ảnh"
                                  v-model="whybuy.alt_image"
                                  placeholder="Nhập alt"
                              ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-row>
                </v-col>
            </v-col>
        </v-col>

        <v-col cols="12">
          <v-row>
            <v-col cols="12" class="content_category mr-2 rounded-lg">
              <v-col class="mx-1">
                <v-row>
                    <h3 class="ml-3 mt-2">Mô tả</h3>
                    <v-btn
                      class="ml-5 mb-5"
                      color="primary"
                      @click="addDescription()"
                    >
                      Thêm
                    </v-btn>
                </v-row>
                <v-row>
                  <v-col>
                    <v-divider></v-divider>
                    <div
                      class="content_property mt-5 rounded-lg"
                      v-for="(item, index) in descriptions"
                      :key="index"
                    >
                      <v-col cols="12" class="mb-3">
                        <v-row>
                            <v-row>
                                <v-col cols="12">
                                <v-text-field
                                    background-color="#EDF2F7"
                                    filled
                                    label="Tiêu đề"
                                    v-model="item.title"
                                    placeholder="Tiêu đề"
                                ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                <v-text-field
                                    background-color="#EDF2F7"
                                    filled
                                    label="Tiêu đề con"
                                    v-model="item.sub_title"
                                    placeholder="Tiêu đề con"
                                ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                <v-text-field
                                    background-color="#EDF2F7"
                                    filled
                                    label="Tiêu đề chính"
                                    v-model="item.main_title"
                                    placeholder="Tiêu đề chính"
                                ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row>
                            <h3 class="ml-1 mt-2 mb-3">Mô tả</h3>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="mb-3">
                        <v-row>
                            <v-row>
                                <v-col cols="12" class="content-textarea">
                                    <v-textarea
                                        background-color="#EDF2F7"
                                        filled
                                        label="Mô tả"
                                        v-model="item.description"
                                        placeholder="Nhập mô tả ngắn"
                                    >
                                    </v-textarea>
                                </v-col>
                            </v-row>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="mb-3">
                        <v-row>
                            <v-row>
                                <v-col cols="3">
                                  <v-file-input
                                    label="Ảnh"
                                    placeholder="Tải ảnh lên"
                                    prepend-icon="mdi-camera"
                                    @change="fileSelectDescription($event, index)"
                                  ></v-file-input>
                                  <v-img :src="item.photo_url_path"></v-img>
                                  <v-text-field v-if="item.photo_url_path"
                                      background-color="#EDF2F7"
                                      filled
                                      label="Alt ảnh"
                                      v-model="item.alt_image"
                                      placeholder="Nhập alt"
                                  ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-row>
                      </v-col>

                      <v-col>
                        <div style="display: flex; justify-content: flex-end">
                          <v-btn color="primary" @click="clearDescription(index)">
                            Xóa
                          </v-btn>
                        </div>
                      </v-col>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-col cols="12" class="text-center mt-3">
        <v-btn color="primary" width="180" @click="save()"> Lưu </v-btn>
      </v-col>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  GET_CONFIG_WHYBUY,
  UPDATE_CONFIG_WHYBUY,
  UPLOAD_IMAGE,
} from "@/store/modules/configs";
import FormLink from "@/views/Pages/config/util/form_link";

export default {
  components: { FormLink },
  data() {
    return {
      descriptions: [],
      description: {
          title: "",
          sub_title: "",
          main_title: "",
          description: "",
          photo_url: "",
          photo_url_path: "",
          number: null,
      },
      banners: [],
      banner: {
          alt_image: "",
          alt_image_mobile: "",
          photo_url: "",
          photo_url_mobile: "",
          type: null,
          link: {
            type: null,
            object_id: null,
            url: null,
          }
      },
      whybuy: {
          photo_url: "",
          photo_url_path: "",
          title: "",
          sub_title: "",
          description: "",
      },
      list_type: [
        {
          id: "category",
          text: "category",
        },
        {
          id: "brand",
          text: "brand",
        },
        {
          id: "tag",
          text: "tag",
        },
      ],
      types: [
        {
          id: 1,
          text: "Link theo loại",
        },
        {
          id: 2,
          text: "Link theo URL",
        },
      ],
      image: {},
      src: "",
      category: {
        id: -1,
      },
      page: "Quản lý tại sao mua hàng",

      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý trang",
          disabled: true,
        },
        {
          text: "Tại sao mua hàng",
          disabled: true,
        },
      ],
      errors: 0,
      text_seo: "",
      SEO: [],
    };
  },
  computed: {
    ...mapGetters({
      config_whybuy: "config_whybuy",
    }),
  },
  watch: {
    config_whybuy(val) {
      this.whybuy = val.whybuy ?? this.whybuy;
      this.descriptions = val.description ?? [];
      this.banners = val.banner ?? [];
    },
  },
  async created() {
    await this.$store.dispatch(`${GET_CONFIG_WHYBUY}`);
  },
  mounted() {
    
  },
  methods: {
    addDescription() {
      this.descriptions.push(this.description);
    },
    clearDescription(i) {
      this.descriptions.splice(i, 1);
      this.$forceUpdate();
    },
    fileSelectWhyBuy(event) {
      if (event) {
        this.whybuy.photo_url_path = URL.createObjectURL(event);
        let formData = new FormData();
        formData.append("upload", event);
        formData.append("type", "configs");
        this.$store
          .dispatch(`${UPLOAD_IMAGE}`, formData)
          .then((data) => {
            if (data && data.data && data.data.data) {
              data.data.data.forEach((element) => {
                this.whybuy.photo_url = element.path;
                this.whybuy.photo_url_path = element.url;
              });
            }
          });
      }
    },
    fileSelectDescription(event, index) {
      if (event) {
        this.descriptions[index].photo_url_path = URL.createObjectURL(event);
        let formData = new FormData();
        formData.append("upload", event);
        formData.append("type", "configs");
        this.$store
          .dispatch(`${UPLOAD_IMAGE}`, formData)
          .then((data) => {
            if (data && data.data && data.data.data) {
              data.data.data.forEach((element) => {
                this.descriptions[index].photo_url = element.path;
                this.descriptions[index].photo_url_path = element.url;
              });
            }
          });
      }
    },
    save() {
      let _this = this;
      let body = {
        banner: this.banners,
        whybuy: this.whybuy,
        description: this.descriptions,
      };
      if (body.banner.type == 1) {
        body.banner.link.url = null;
      }
      if (body.banner.type == 2) {
        body.banner.link.object_id = null;
        body.banner.link.type = null;
      }
      this.$store
        .dispatch(`${UPDATE_CONFIG_WHYBUY}`, body)
        .then((data) => {
          if (data.data.status === 1) {
            this.$toasted.success('Cập nhật thành công!', {
              duration:1000,
              position:'top-center'
            })
            _this.$store.dispatch(`${GET_CONFIG_WHYBUY}`);
          } else {
            alert(data.data.errors);
          }
        });
    },
    addBanner() {
      this.banners.push({
        alt_image: this.banner.alt_image,
        alt_image_mobile: this.banner.alt_image_mobile,
        photo_url: this.banner.photo_url,
        photo_url_mobile: this.banner.photo_url_mobile,
        type: this.banner.type,
        link: this.banner.link,
      });
    },
    updateBanner(val) {
      this.banners[val.index] = val.banner
    },
    removeBanner(i) {
      this.banners.splice(i, 1);
      this.$forceUpdate();
    }
  },
};
</script>
<style lang="scss">
.content_property {
  padding: 15px;
  border-style: groove;
}
.content_banner {
  padding: 15px;
  border-style: groove;
}
.content_category1 {
  background: #ffffff !important;
}
.content_category {
  background: #ffffff !important;
  .v-input__control {
    height: 65px !important;
  }
  .content-textarea .v-input__control {
    height: 165px !important;
  }
  .v-input--checkbox .v-input__control {
    height: 20px !important;
  }
}
.production .ck-editor__main .ck-content {
  height: 140px;
}
.right {
  float: right;
}
</style>